import request from '@/util/request'
import localCache from '../util/localCache';

export function addSupplier(params) {
    params.token = localCache.getToken()
    return request({
        url: '/supplier',
        method: 'post',
        params
    })
}
export function updateSupplier(params) {
    params.token = localCache.getToken()
    return request({
        url: '/updateSupplier',
        method: 'post',
        params
    })
}
export function deleteSupplier(params) {
    params.token = localCache.getToken()
    return request({
        url: '/deleteSupplier',
        method: 'post',
        params
    })
}
export function getSupplierPageList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getSupplierPageList',
        method: 'get',
        params
    })
}
export function getSupplierList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getSupplierList',
        method: 'get',
        params
    })
}
export function updateSupplierStartBalance(params) {
    params.token = localCache.getToken()
    return request({
        url: '/updateSupplierStartBalance',
        method: 'post',
        params
    })
}
